import { createClient } from 'next-sanity';

export const sanityToken = process.env.NEXT_PUBLIC_SANITY_API_READ_TOKEN;

export const sanityClient = createClient({
  projectId: process.env.NEXT_PUBLIC_SANITY_PROJECT_ID,
  dataset: process.env.NEXT_PUBLIC_SANITY_DATASET,
  useCdn: false,
  apiVersion: 'v2025-03-04',
  perspective: 'published',
  token: process.env.NEXT_PUBLIC_SANITY_API_READ_TOKEN,
  stega: {
    enabled: false,
    studioUrl:
      process.env.NODE_ENV === 'production'
        ? 'https://sanity.fagmobler.no'
        : 'http://localhost:3333',
  },
});

export const sanityClientPrivate = createClient({
  projectId: process.env.NEXT_PUBLIC_SANITY_PROJECT_ID,
  dataset: 'private',
  useCdn: false,
  apiVersion: 'v2025-03-04',
  withCredentials: false,
  token: process.env.SANITY_WRITE_TOKEN,
});
